import React from 'react'

const HEART_PATH =
  'M13.5865 25.1257L14 25.3989L14.4135 25.1257C20.3001 21.2361 23.743 17.5125 25.4355 14.1736C27.1374 10.8161 27.0697 7.8338 25.9022 5.55377C23.7232 1.29829 17.7813 -0.241906 14 2.94703C10.2187 -0.241906 4.27685 1.29829 2.09782 5.55377C0.930327 7.8338 0.862629 10.8161 2.56453 14.1736C4.25698 17.5125 7.69994 21.2361 13.5865 25.1257Z'

const IconHeartStrokeCenterCard = ({
  className
}: {
  className: string
}): JSX.Element => {
  const svgString = `
    <svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="${HEART_PATH}" fill="white"/>
    </svg>
  `
  const maskUrl = `url("data:image/svg+xml,${encodeURIComponent(svgString)}")`

  return (
    <div className="group relative flex size-6 items-center justify-center">
      <div className="relative">
        <div
          className="absolute inset-0 bg-stone-800/55 backdrop-blur transition-all duration-300 group-hover:backdrop-blur-0"
          style={{
            maskImage: maskUrl,
            WebkitMaskImage: maskUrl,
            maskSize: 'contain',
            WebkitMaskSize: 'contain',
            maskRepeat: 'no-repeat',
            WebkitMaskRepeat: 'no-repeat'
          }}
        />
        <svg
          className={`relative z-10 ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="27"
          viewBox="0 0 28 27"
          aria-label="Heart Icon"
          role="img"
          fill="none"
        >
          <path
            d={HEART_PATH}
            fill="none"
            stroke="white"
            strokeWidth="1.5"
          />
        </svg>
      </div>
    </div>
  )
}

export default IconHeartStrokeCenterCard
